import { Box, Grid } from "@mui/material";
import { Formik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../common/Button";
import OrganizationStructure from "../common/OrganizationStructure/OrganizationStructure";
// import CustomAutoComplete from "../CustomAutoComplete/index";
// import CustomTextField from "../textField";
import {
  LABELS,
  NEW_ENTRY_FIELDS,
  ORGANIZATION_STRUCTURE_FIELDS,
} from "../../contants/formFields";
// import InputField from "../common/InputField/InputField";
import InputField from "../common/new/InputField/InputField";
import Toast from "../common/Toast";
import styles from "./styles";

import IntroductionFormApi from "../../services/api/introductionForm";
import { formValidation } from "./AssignRequest";
// import { divPrimary, divSecondary, textFieldStyle, buttonStyle } from "./styles";

function AcceptTransferRequest({ selectedItem, onFinalSubmit }) {
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [showToast, setShowToast] = useState(null);
  const navigate = useNavigate();
  // const selectedIntroduction = useSelector(
  //   (store) => store.view_introduction.selectedIntroduction
  // );

  const getState = async () => {
    const response = await IntroductionFormApi.getStates();
    if (response?.data) {
      const filteredState = response.data.filter((s) => {
        return s.stateId === Number(selectedItem.state);
      });
      if (filteredState.length > 0) {
        setState(filteredState[0].stateName);
        const filteredCity = filteredState[0].cities.filter((c) => {
          return c.cityId === Number(selectedItem.city);
        });
        if (filteredCity.length > 0) {
          setCity(filteredCity[0].cityName);
        }
      }
    }
  };

  useEffect(() => {
    getState();
  }, []);
  return (
    <Box sx={{ p: "1rem" }}>
      <Formik
        enableReinitialize
        initialValues={{
          [ORGANIZATION_STRUCTURE_FIELDS.REGION]:
            selectedItem?.targetOrganizationStructure?.targetOrgRegionId,
          [ORGANIZATION_STRUCTURE_FIELDS.ZONE]:
            selectedItem.targetOrganizationStructure?.targetOrgZoneId,
          [ORGANIZATION_STRUCTURE_FIELDS.AREA]:
            selectedItem.targetOrganizationStructure?.targetOrgAreaId,
          [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]:
            selectedItem.targetOrganizationStructure?.targetOrgDistrictId,
          [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]:
            selectedItem.targetOrganizationStructure?.targetOrgChapterId,
          [NEW_ENTRY_FIELDS.ADDRESS_LINE_1]: selectedItem.addressLine1,
          // [NEW_ENTRY_FIELDS.ADDRESS_LINE_2]: selectedItem.addressLine2,
          [NEW_ENTRY_FIELDS.CITY]: city,
          [NEW_ENTRY_FIELDS.STATE]: state,
          [NEW_ENTRY_FIELDS.PINCODE]: selectedItem.pincode,
          [NEW_ENTRY_FIELDS.CONTACT_NUMBER]: selectedItem.mobileNumber,
          [NEW_ENTRY_FIELDS.EMAIL_ADDRESS]: selectedItem.emailId,
        }}
        onSubmit={(values) => {
          const dataToSend = { ...values, transferId: selectedItem.transferId };
          dataToSend[NEW_ENTRY_FIELDS.STATE] = selectedItem.state;
          dataToSend[NEW_ENTRY_FIELDS.CITY] = selectedItem.city;
          const error = formValidation(dataToSend);

          if (error || !dataToSend.blockId) {
            setShowToast({
              message: !dataToSend.blockId ? "Block cannot be empty" : error,
              severity: "error",
            });
            return;
          }
          onFinalSubmit(dataToSend, selectedItem, navigate, setShowToast);
          // postData(values);
        }}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          setFieldValue,
          /* and other goodies */
        }) => (
          <Box
            style={{
              display: "flex",
            }}
          >
            <Box
              style={{
                width: "40%",
                padding: "1rem 1.6rem",
              }}
            >
              <OrganizationStructure
                values={values}
                handleChange={handleChange}
                errors={errors}
                setFieldValue={setFieldValue}
                showBlock
                isLoading={false}
                showZoneLocator={false}
              />
            </Box>

            <Box sx={{ width: "60%", py: 20, px: "1rem" }}>
              <Grid container spacing={2}>
                <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    required
                    label={LABELS.ADDRESS_LINE_1}
                    name={NEW_ENTRY_FIELDS.ADDRESS_LINE_1}
                    onChange={handleChange}
                    style={styles.customTextFieldSecondary}
                    value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
                  />
                </Grid>
                {/* <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    label={LABELS.ADDRESS_LINE_2}
                    name={NEW_ENTRY_FIELDS.ADDRESS_LINE_2}
                    onChange={handleChange}
                    style={styles.customTextFieldSecondary}
                    value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
                  />
                </Grid> */}
                <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    required
                    optionLabelId="cityName"
                    options={[]}
                    label={LABELS.CITY}
                    name={NEW_ENTRY_FIELDS.CITY}
                    onChange={handleChange}
                    style={styles.customTextFieldSecondary}
                    value={values[NEW_ENTRY_FIELDS.CITY]}
                    disabled
                  />
                </Grid>
                <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    required
                    label={LABELS.STATE}
                    style={styles.customTextFieldSecondary}
                    name={NEW_ENTRY_FIELDS.STATE}
                    onChange={handleChange}
                    value={values[NEW_ENTRY_FIELDS.STATE]}
                    disabled
                  />
                </Grid>
                <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    label={LABELS.PINCODE}
                    style={styles.customTextFieldSecondary}
                    name={NEW_ENTRY_FIELDS.PINCODE}
                    onChange={handleChange}
                    value={values[NEW_ENTRY_FIELDS.PINCODE]}
                    inputProps={{
                      maxLength: 6,
                    }}
                  />
                </Grid>
                {/* <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    label={LABELS.DOB}
                    name={NEW_ENTRY_FIELDS.DATE_OF_JOINING}
                    onChange={handleChange}
                    style={styles.customTextFieldSecondary}
                    value={values[NEW_ENTRY_FIELDS.DATE_OF_JOINING]}
                  />
                </Grid> */}
                <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    required
                    label={LABELS.CONTACT_NUMBER}
                    style={styles.customTextFieldSecondary}
                    name={NEW_ENTRY_FIELDS.CONTACT_NUMBER}
                    onChange={handleChange}
                    value={values[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                </Grid>
                <Grid item md={6} sm={12} style={styles.gridPrimary}>
                  <InputField
                    label={LABELS.EMAIL_ADDRESS}
                    style={styles.customTextFieldSecondary}
                    name={NEW_ENTRY_FIELDS.EMAIL_ADDRESS}
                    onChange={handleChange}
                    value={values[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
                  />
                </Grid>
                <Box
                  mt={4}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <Button
                    label="Accept"
                    onClick={() => {
                      handleSubmit();
                    }}
                  />
                </Box>
              </Grid>
            </Box>
          </Box>
        )}
      </Formik>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

const propTypes = {
  selectedItem: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onFinalSubmit: PropTypes.func.isRequired,
};

AcceptTransferRequest.propTypes = propTypes;

export default AcceptTransferRequest;
